/**
 * BeCoder Sprint 0 — cinematic atmosphere layers (visual only).
 * V4 Channel Atmosphere · V2 Quiet Daylight
 * Alive through light drift — not through geometric symbols.
 */
import React from 'react';

export type AtmosphereMode = 'channel' | 'daylight';

type AtmosphereProps = {
  mode: AtmosphereMode;
  className?: string;
  /** When true, fills a positioned parent instead of the viewport */
  contained?: boolean;
  /** Auth stage: right-weighted light, never a centered symbol */
  signature?: 'quiet' | 'focal';
};

export const Atmosphere: React.FC<AtmosphereProps> = ({
  mode,
  className = '',
  contained = false,
  signature = 'quiet',
}) => {
  const rootClass = [
    'bc-atmosphere',
    mode === 'channel' ? 'bc-atmosphere--channel' : 'bc-atmosphere--daylight',
    signature === 'focal' ? 'bc-atmosphere--signature-focal' : '',
    contained ? 'bc-atmosphere--contained' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} aria-hidden="true">
      <div className="bc-atmosphere__base" />
      <div className="bc-atmosphere__mist" />
      <div className="bc-atmosphere__bloom" />
      <div className="bc-atmosphere__bloom bc-atmosphere__bloom--secondary" />
      <div className="bc-atmosphere__volume" />
      <div className="bc-atmosphere__haze" />
      <div className="bc-atmosphere__depth" />
      <div className="bc-atmosphere__veil" />
    </div>
  );
};
